
import styled from "styled-components";
import theme from "./../../styles/theme"

export const CommitmentsSection = styled.section`
  background:  url('https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/commitments/commitments.png') center / cover;
  padding-top  : 30px;
  padding-bottom: 80px;

  @media (max-width:  ${theme.breakpoints.medium}) {
    .slick-slider{
      display: flex;
      justify-content: center;
      max-width: 360px;
      padding: 0 0 0 20px;
      padding-top: 50px;
    }
  }

  h2 {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;

    @media (max-width:  ${theme.breakpoints.medium}){
      color: ${theme.colors.gray};
    }

  }

  h3{
    color: ${theme.colors.white};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.xxLarge};
  }
`;


export const CommitmentsBox = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  padding-top: 60px;

  @media (max-width:  ${theme.breakpoints.medium}){
   padding: 60px 20px 0;
  }
`;

export const CommitmentsCard = styled.div`
  background: ${theme.colors.white};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.01), 0px 4px 8px rgba(0, 0, 0, 0.02), 0px 1px 12px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 1100px;
  padding: 24px;
  width: 100%;

  ul {
    padding-left: 30px;
  }

  li {
    color: ${theme.colors.gray};
    font-family: ${theme.fonts.montSerrat};
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    padding: 15px 0 0;
    text-align: initial;

    ::marker {
    color:  ${theme.colors.landingTheme};
    font-size: 22px;
  }
  }
`;

export const CommitmentsDescription = styled.div`
  padding: 30px 10px 30px 20px;
`;

export const CommitmentsTitle = styled.h4`
  font-family: ${theme.fonts.montSerrat};
  font-weight: 800;
  font-size: 20px;
  line-height: 24px;
  color: ${theme.colors.gray};
  text-align: initial;
`;

export const CommitmentsSubTitle = styled.li`
  color: ${theme.colors.gray};
  font-family: ${theme.fonts.montSerrat};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  padding-top: 15px;
  text-align: initial;

  ::marker {
    color:  ${theme.colors.landingTheme};
  }

`;

export const Commitmentslist = styled.ul`
  list-style: disc;
  color:  ${theme.colors.landingTheme};
  padding: 10px 5px 10px 15px;
`;
